import React from 'react';
import { Box } from '@mui/material';
import StepReferenceTextField from 'components/CreateSpark/StepReferenceTextField';
import SparkTextField from './SparkTextField';

type SparkDynamicTextAreaInputFieldProps = {
  name: string;
  label: string | null | undefined;
  helpText: string | null | undefined;
  subHeaderText: string | null | undefined;
  placeholder: string | null | undefined;
  isFieldMappable?: boolean;
};

function SparkDynamicTextAreaInputField({
  name,
  helpText = '- -',
  label: headerText = '',
  placeholder: placeholderText = '',
  subHeaderText = '',
  isFieldMappable = false,
}: SparkDynamicTextAreaInputFieldProps) {
  return (
    <Box width='100%' position='relative'>
      {isFieldMappable ? (
        <StepReferenceTextField
          label={headerText || '- -'}
          name={name}
          key={name}
          helpText={helpText || ''}
          subHeaderText={subHeaderText || ''}
          placeholder={''}
        />
      ) : (
        <SparkTextField
          key={name}
          name={name}
          label={headerText || '- -'}
          placeholder={placeholderText || ''}
          helpText={helpText || ''}
          subHeaderText={subHeaderText || ''}
          size={12}
          multiline={true}
          rows={3}
        />
      )}
    </Box>
  );
}

export default SparkDynamicTextAreaInputField;
